import React, { Component } from "react";
import styles from "./Modal.scss";
import classnames from "classnames";

class ConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: undefined,
      new_data: undefined,
      coupon_type: undefined
    };
  }

  render() {
    const showHideClassName = this.props.show
      ? styles.modalDisplayBlock
      : styles.modalDisplayNone;

    return (
      <div className={showHideClassName}>
        <section className={styles.confirmModal}>
          {this.props.children}
          <span>Confirm Delete?</span>
          <div className={styles.confirmButtons}>
            <button
              className={classnames("btn btn-primary pink z-depth-0", styles.modalButtons)}
              onClick={() => {
                this.props.deleteData(this.props.data, this.props.type);
                this.props.handleClose();
              }}
            >
              yes
            </button>
            <button
              className={classnames("btn btn-primary pink z-depth-0", styles.modalButtons)}
              onClick={() => this.props.handleClose()}
            >
              no
            </button>
          </div>
        </section>
      </div>
    );
  };
}

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/pages/Admin/ConfirmModal.js